<script setup>
const props = defineProps({
    label: { type: String, required: true },
    onClick: { type: Function, required: true },
    tooltip: { type: String },
    disabled: { type: Boolean, required: false, default: false },
});
</script>

<template>
    <button
        type="button"
        @click="props.onClick"
        :disabled="props.disabled"
        class="standard-button disabled:cursor-not-allowed font-medium"
        data-bs-toggle="tooltip"
        data-bs-placement="top"
        :title="props.tooltip || props.label"
    >
        <slot></slot>
        {{ props.label }}
    </button>
</template>
